var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isVisible),expression:"isVisible"}],ref:"mouseTip",staticClass:"mouse-tip-box"},[_c('div',[_vm._v(_vm._s(_vm.mouseTipContent))])])
}
var staticRenderFns = []

export { render, staticRenderFns }